import classNames from 'classnames';

import Form from '../forms/Form';

import styles from '../../styles/blocks/form-block.module.css';

interface FormBlockProps {
    form: Form;
    className?: string;
}

function FormBlock({ form, className, ...props }: FormBlockProps) {
    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.inner}>
                <Form form={form} {...props} />
            </div>
        </div>
    );
}

export default FormBlock;
